import React from 'react'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { BarLoader } from 'react-spinners'
import styled from 'styled-components'

import {
  FACEBOOK_APP_ID,
  FACEBOOK_FIELDS,
  FACEBOOK_SCOPE,
} from '../../constants/config'

const FacebookButton = styled.button`
  width: 100%;
  min-height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 50px;
  border: 2px solid #3b5998;
  font-family: gotham, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  background: linear-gradient(to bottom, #4c70ba, #2d5b9b);
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover:not(:disabled) {
    box-shadow:
      inset 0 0 0 1px rgba(0, 0, 0, 0.1),
      0 4px 8px rgba(0, 0, 0, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`

export function FacebookLoginButton ({ callback, loading, label = 'Facebook login' }) {
  return (
    <FacebookLogin
      autoLoad
      appId={FACEBOOK_APP_ID}
      fields={FACEBOOK_FIELDS}
      scope={FACEBOOK_SCOPE}
      disableMobileRedirect
      callback={callback}
      render={(renderProps) => {
        const isDisabled = renderProps.isDisabled || loading || renderProps.isProcessing

        return (
          <FacebookButton
            type='button'
            disabled={isDisabled}
            onClick={isDisabled ? undefined : renderProps.onClick}
          >
            {renderProps.isProcessing || loading
              ? <BarLoader color='#fff' size={8} />
              : label}
          </FacebookButton>
        )
      }}
    />
  )
}

export default FacebookLoginButton
